export default __webpack_public_path__ + "static/20_JULIO_UNO-0de30fbf411fe8b8a17401ad1488b181.jpg";